import { defineStore } from "pinia";

export enum AlertType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}

interface AlertModel {
  message: string;
  visible: boolean;
  icon: string;
  type: AlertType;
  autoClose: boolean;
  top: boolean;
  timer: null | number
}

const model: AlertModel = {
  message: "",
  visible: false,
  icon: "mdi-information",
  type: AlertType.Info,
  autoClose: true,
  top: false,
  timer: null
};

interface AlertParams {
  message?: string;
  icon?: string;
  type?: AlertType;
  visible?: boolean;
  autoClose?: boolean;
  top?: boolean;
  time?: number;
}

export const useAlert = defineStore("alert", {
  state: (): AlertModel => ({ ...model }),
  actions: {
    setCurrent(params: AlertModel) {
      this.message = params.message || "";
      this.icon = params.icon || "mdi-information";
      this.type = params.type || AlertType.Info;
      this.visible = params.visible ?? false;
      this.autoClose = params.autoClose ?? true;
      if( this.timer ){
        clearTimeout(this.timer)
      }
    },
    fire(params: AlertParams) {
      this.message = params.message || "";
      this.icon = params.icon || "mdi-information";
      this.type = params.type || AlertType.Info;
      this.visible = true;
      this.top = params.top ?? false;
      const time = params.time ?? 4000;
      if (this.autoClose) {
        this.timer = setTimeout(() => {
          this.reset();
        }, time);
      }
    },
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
      if( this.timer ){
        clearTimeout(this.timer)
      }
    },
    reset() {
      this.setCurrent(model);
    },
  },
  getters: {
    // Add any getters here if needed
  },
});
